import React, {PureComponent} from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper/index'
import {TableComp} from 'sz-react-utils'
// import GetAllFormFields from '../../../components/_utils/formUtils'
import {Button, Card, Form,Row,Col, Tooltip, DatePicker, Select, Tabs, notification} from 'antd'
import _ from 'lodash'
import Request from '../../request'
import {connect} from 'react-redux'
import moment from 'moment'



const {MonthPicker} = DatePicker
const Option = Select.Option;
const TabPane = Tabs.TabPane

@Form.create()
class AbsentStaff extends PureComponent {
    state = {
        count: 0,
        totalPresent:0,
        defaultPageSize: 50,
        activeTab:'0'
    }



    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    stopStaffTimer = async(recordId)=>{
        let response = await Request.stopEmployeeTimer({userId:recordId, logoutTime: moment()})
        if(response.success) {
            notification.success({
                message:'Timer Stopped Sucessfully'
            })
            this.table.current.reload()
        }
    }

    chooseTab(value) {
        this.setState({
          activeTab: value
        })
      }

    callback = (value) => {
        if (value) {
          this.chooseTab(value)
        }
      }
      
    apiRequest = params =>{
        return new Promise(async(resolve)=>{
            let response = await Request.getAbsentEmployees({date:moment().format('YYYY-MM-DD')})
            this.setState({count:response.total})
            resolve(response)
        })
    }
    apiPresentRequest = params =>{
        return new Promise(async(resolve)=>{
            let response = await Request.getPresentEmployees(params)
            this.setState({totalPresent:response.total})
            resolve(response)
        })
    }


    render() {
        const {defaultPageSize, count} = this.state
        const columns = [
            {
                title:'Employee Name',
                key:'name'
            },
            {
                title: 'Mobile Number',
                key: 'contactNo',
            },
            {
                title: 'Email Id',
                key: 'email',
            },
            {
                title: 'Group Name',
                key: 'userGroup.groupName',
            }
        ]


        const presentColumns = [
            {
                title:'Employee Name',
                key:'userId.name'
            },
            {
                title: 'Login At',
                key: 'loginAt',
            },
            {
                title:'Action',
                key:'Operation',
                render:(text,record)=>(
                    <React.Fragment>
                        <Tooltip title={`Click to Stop ${record.userId.name} Timer`}>
                            <Button
                                    shape="circle"
                                    onClick={()=>this.stopStaffTimer(record.userId)}
                                    icon="stop"
                            />
                        </Tooltip>
                    </React.Fragment>
                )
            }
        ]

    return (
        
        <PageHeaderWrapper title={this.state.activeTab === "0"?`Employees Absent Today: ${this.state.count}`:`Employees Present Today: ${this.state.totalPresent}` }>
            <Card bordered={true} >
                <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab} destroyInactiveTabPane>
                <TabPane tab={'Absent Employees'} key={0}>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        pagination={{
                        showSizeChanger: false,
                        defaultPageSize: defaultPageSize,
                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </TabPane>
                <TabPane tab={"Present Employees"} key={1}>
                    <TableComp
                        ref={this.table}
                        columns={presentColumns}
                        apiRequest={this.apiPresentRequest}
                        pagination={{
                        showSizeChanger: true,
                        defaultPageSize: defaultPageSize,
                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </TabPane>
                </Tabs>
            </Card>
        </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AbsentStaff)
